
import { Component, Prop } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import AttachmentMixin from '@/_mixins/attachment'

@Component({
    mixins: [AttachmentMixin],
})
export default class Avatar extends Mixins<MixinInterface>(AttachmentMixin) {
    @Prop() user!: any
    @Prop({ default: 48 }) size!: any

    getInit() {
        let initials = ''
        let name = this.user?.name

        if (!name) return ''

        let words = name.split(/\s/)
        words.map((word, index) => {
            if (index == 0 || index == words.length - 1) {
                initials += word.slice(0, 1).toUpperCase()
            }
        })
        return initials
    }

    get initials() {
        return this.user ? this.getInit() : null
    }

    get avatar() {
        return this.user?.avatarFileId ? this.getPreview(this.user.avatarFileId) : null
    }
}
